import classNames from 'classnames';
import React, {forwardRef, PropsWithChildren, ReactNode} from 'react';
import styles from './PropertyCarousel.module.scss';
import {PropertyCarouselCanvasPlaceholder} from './PropertyCarouselCanvasPlaceholder';
import {PropertyCarouselSlide} from './PropertyCarouselSlide';

export type PropertyCarouselProps = {
    emblaRef: any;
    navButtons?: ReactNode;
    variant?: 'simple';
};

export const PropertyCarousel = forwardRef<HTMLDivElement, PropsWithChildren<PropertyCarouselProps>>(
    ({emblaRef, navButtons, variant, children}, ref) => {
        return (
            <div
                ref={ref}
                className={classNames(styles.propertyCarousel, 'propertyCarousel', {
                    [styles[`propertyCarousel--${variant}`]]: variant,
                })}
            >
                <div className={styles.propertyCarouselViewport} ref={emblaRef}>
                    <div className={styles.propertyCarouselContainer}>{children}</div>
                </div>

                {navButtons && <div className={styles.propertyCarouselNav}>{navButtons}</div>}
            </div>
        );
    },
);

export default Object.assign(PropertyCarousel, {
    CanvasPlaceholder: PropertyCarouselCanvasPlaceholder,
    Slide: PropertyCarouselSlide,
});
